import { gql } from 'apollo-angular';
import { BASEMODEL_FRAGMENT } from './base-definition';
import { INTEGRATION_FRAGMENT } from './integration-connection-definition';
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const PRODUCT_GROUP_INTEGRATION_LINK_FRAGMENT = gql`
    fragment ProductGroupIntegrationLink on ProductGroupIntegrationLink {
        ...IBaseModel
        productGroupId
        integrationId
        integration {
            ...IntegrationConnection
        }
        externalEntityId
        lockShopCategory
        lastSyncDate
    }
    ${BASEMODEL_FRAGMENT}
    ${INTEGRATION_FRAGMENT}
`;

export const GET_PRODUCT_GROUP_INTEGRATION_LINKS = gql`
    query GetProductGroupIntegrationLinks($input: ProductGroupIntegrationLinkSearchInput) {
        getProductGroupIntegrationLinks(input: $input) {
            totalItems
            items {
                ...ProductGroupIntegrationLink
            }
        }
    }
    ${PRODUCT_GROUP_INTEGRATION_LINK_FRAGMENT}
`;

export const SAVE_PRODUCT_GROUP_INTEGRATION_LINK = gql`
    mutation SaveProductGroupIntegrationLink($input: ProductGroupIntegrationLinkInput!) {
        saveProductGroupIntegrationLink(input: $input) {
            ...ProductGroupIntegrationLink
        }
    }
    ${PRODUCT_GROUP_INTEGRATION_LINK_FRAGMENT}
`;

export const DELETE_PRODUCT_GROUP_INTEGRATION_LINK = gql`
    mutation DeleteProductGroupIntegrationLink($id: String!) {
        deleteProductGroupIntegrationLink(id: $id) {
            ...DeletionResponse
        }
    }
    ${DELETION_RESPONSE_FRAGMENT}
`;
